import s from './style.css';
import { Component } from 'preact';
import cn from 'classnames';
import Container from 'components/Container';
import Section from 'components/RomanceBreakdownViz/Section';
import Label from 'components/RomanceBreakdownViz/Label';
import Images from 'components/RomanceBreakdownViz/Images';

const supportsSticky = () => {
	const el = document.createElement('a');
	let style = el.style;
	style.cssText = 'position:sticky;position:-webkit-sticky;';
	return style.position.indexOf('sticky') !== -1;
};

class RomanceBreakdownViz extends Component {
	constructor(props) {
		super(props);
		this.triggers = [];
		this.observer = [];
		this.state = { current: 0, seen: {} };
		this.updateCurrent = this.updateCurrent.bind(this);
	}

	updateCurrent(entries) {
		entries.forEach((entry, i) => {
			if (entry.intersectionRatio > 0.5) {
				const current = +entry.target.id;
				this.setState({
					current,
					seen: {
						...this.state.seen,
						[current - 1]: true,
						[current]: true,
						[current + 1]: true
					}
				});
			}
		});
	}

	componentWillMount() {
		if (typeof window !== 'undefined') {
			this.observer = new IntersectionObserver(this.updateCurrent, {
				rootMargin: '0px',
				threshold: [0, 0.5, 1]
			});

			this.setState({
				supportsSticky: supportsSticky()
			});
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextState.current !== this.state.current ||
			nextState.seen !== this.state.seen ||
			nextProps.loaded !== this.props.loaded
		);
	}

	componentWillUpdate(nextProps) {
		if (!this.props.loaded && nextProps.loaded) {
			this.setState({
				seen: {
					...this.state.seen,
					0: true,
					1: true
				}
			});
		}
	}

	render() {
		const { sections, data } = this.props;
		const { current, seen, supportsSticky } = this.state;
		const columns = 77;
		const max = 5795;

		return (
			<div className={cn(s.root)} data-supports-sticky={!supportsSticky}>
				<Container>
					<div className={s.extra}>
						<div className={s.viz} id={'working-with-the-one-you-love'}>
							<div className={s.vizInner}>
								<div className={s.wrap}>
									{sections.map((section, i) => (
										<div className={s.ieWrap}>
											<div className={s.imageSizer}>
												<div className={s.imageWrap}>
													{(i === current - 1 ||
														i === current ||
														i === current + 1) && (
														<Images
															id={i}
															isVisible={i <= current}
															hasBeenSeen={seen[i]}
														/>
													)}
													{data[i].groups.map((group, j) => (
														<div className={s.labelSizer}>
															<Label
																id={i}
																{...group}
																columns={columns}
																max={max}
																visible={current === i}
																isTight={data[i].groups.length > 1}
																isSecondary={j > 0}
															/>
														</div>
													))}
												</div>
											</div>
										</div>
									))}
								</div>
							</div>
						</div>
					</div>

					<Sections
						sections={sections}
						observer={this.observer}
						current={current}
						supportsSticky={supportsSticky}
					/>
				</Container>
			</div>
		);
	}
}

class Sections extends Component {
	shouldComponentUpdate(nextProps) {
		return this.props.current !== nextProps.current;
	}

	render() {
		const { sections, observer, current } = this.props;
		return (
			<div className={s.sections}>
				{sections.map((section, i) => (
					<Section
						id={i}
						{...section}
						observer={observer}
						isLast={i === sections.length - 1}
						isVisible={current === i}
					/>
				))}
			</div>
		);
	}
}

export default RomanceBreakdownViz;



// WEBPACK FOOTER //
// ./components/RomanceBreakdownViz/index.js